import { Branch } from '../DiffMergeTable/Branch';
import { BULK_POPOVER_ATTR } from '@ardoq/popovers';
import { APIEntityType, ArdoqId } from '@ardoq/api-types';

export const withEntitiesListPopover = ({
  branch,
  entityIds,
  entityType,
  parentEntityId,
  width,
}: {
  branch: Branch;
  entityIds: (ArdoqId | number)[];
  entityType: APIEntityType;
  parentEntityId?: ArdoqId;
  width?: string;
}) => ({
  [BULK_POPOVER_ATTR]: 'true',
  'data-diff-merge-popover-branch': branch,
  'data-diff-merge-popover-entity-ids': entityIds.join(','),
  'data-diff-merge-popover-entity-type': entityType,
  'data-diff-merge-popover-parent-entity-id': parentEntityId,
  'data-diff-merge-popover-width': width,
});

export const withWorkspacePopover = ({
  branch,
  entityId,
  entityType,
  parentEntityId,
}: {
  branch: Branch;
  entityId: ArdoqId | number;
  entityType: APIEntityType;
  parentEntityId?: ArdoqId;
}) => ({
  [BULK_POPOVER_ATTR]: 'true',
  'data-diff-merge-popover-branch': branch,
  'data-diff-merge-popover-entity-id': entityId,
  'data-diff-merge-popover-entity-type': entityType,
  'data-diff-merge-popover-parent-entity-id': parentEntityId,
});

export const withComponentModelPopover = ({
  branch,
  modelId,
  highlightedComponentTypeId,
}: {
  branch: Branch;
  modelId: ArdoqId;
  highlightedComponentTypeId?: ArdoqId;
}) => ({
  [BULK_POPOVER_ATTR]: 'true',
  'data-diff-merge-popover-branch': branch,
  'data-diff-merge-popover-model-id': modelId,
  'data-diff-merge-popover-highlighted-component-type-id':
    highlightedComponentTypeId,
});

export const withComponentHierarchyPopover = ({
  componentId,
  branch,
}: {
  branch: Branch;
  componentId: ArdoqId;
}) => ({
  [BULK_POPOVER_ATTR]: 'true',
  'data-diff-merge-popover-branch': branch,
  'data-diff-merge-popover-component-id': componentId,
});
